import { connect } from "react-redux";
import JmsList from "./JmsList";
import { bindActionCreators } from "redux";
import {getJmsList} from "services/redux/installation/jms/action";

const mapStateToProps = (state) => ({
  jmsList: state.jmsReducer.jmsListState,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getJmsList
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(JmsList);

